// ============================================================================
// HEBREW TRANSLATIONS - CHAPTER 6: מסעות השליחות של פאולוס
// ============================================================================
// רמות 66-78 (13 רמות, 39 שאלות)

export const chapter6Translations = {
  name: "מסעות השליחות של פאולוס",
  description: "עד קצוי הארץ...",
  
  spiritualWisdom: {
    principle: "הבשורה מיועדת לכל העמים ויש להכריז עליה לעולם כולו",
    scripture: "לכו ועשו את כל העמים לתלמידים (מתי 28:19)",
    application: "כל נוצרי נקרא להיות עד למשיח במקום שבו אלוהים מציב אותו"
  },
  
  levels: {
    66: {
      name: "מסע השליחות הראשון",
      challenge: "הפרישו לי את בר-נבא ואת שאול למען המלאכה אשר קראתי אותם...",
      easy: {
        question: "מי ליווה את פאולוס במסעו הראשון?",
        options: ["פטרוס", "בר-נבא", "סילס", "טימותאוס"],
        hint: "'בן הנחמה'",
        funFact: "👥 בר-נבא קיבל את פאולוס לאחר התגלותו - שותפות השגחתית!"
      },
      medium: {
        question: "מאיזו עיר הם יצאו למשימתם?",
        options: [
          "ירושלים",
          "אנטיוכיה בסוריה",
          "טרסוס",
          "דמשק"
        ],
        hint: "הקהילה המעורבת הראשונה של יהודים ונוכרים",
        funFact: "🚢 אנטיוכיה: נמל היציאה של בישור העולם המערבי!"
      },
      hard: {
        question: "מה מגלה מסע ראשון זה על האסטרטגיה המיסיונרית?",
        options: [
          "צריך להישאר באזור שלך",
          "הבשורה חוצה את כל הגבולות התרבותיים",
          "רק יהודים יכולים להיוושע",
          "המשימה היא אופציונלית"
        ],
        hint: "מדובר באוניברסליות של המסר",
        funFact: "🌊 לחצות את הים התיכון = לעשות את הצעד לבישור עולמי!"
      }
    },
    
    67: {
      name: "בקפריסין עם אלימס",
      challenge: "הוי, מלא כל מרמה וכל ערמה, בן השטן...",
      easy: {
        question: "איזה קוסם התנגד לפאולוס בקפריסין?",
        options: ["שמעון", "אלימס", "אפולוס", "אלכסנדר"],
        hint: "נביא שקר שרצה להרחיק את המושל",
        funFact: "🪄 העימות הישיר הראשון בין הבשורה לבין הקסם!"
      },
      medium: {
        question: "מה עשה פאולוס לאלימס כעונש?",
        options: [
          "גירש אותו",
          "עיוור אותו זמנית",
          "התעלם ממנו",
          "ויכח איתו"
        ],
        hint: "עיוורון זמני לפתוח לו את העיניים הרוחניות",
        funFact: "👁️ אירוניה אלוהית: מי שסנוור נשמות הופך לעיוור זמנית!"
      },
      hard: {
        question: "כיצד אפיזודה זו ממחישה את כוח הבשורה?",
        options: [
          "אלימות היא הכרחית",
          "האמת האלוהית מתגברת על השקר",
          "צריך להילחם בכל הקוסמים",
          "פאולוס היה נקמני"
        ],
        hint: "מדובר בסמכות אלוהית מול הונאה",
        funFact: "⚡ המושל מאמין כשהוא רואה את הכוח האלוהי - הפגנה יעילה!"
      }
    },

    68: {
      name: "באנטיוכיה בפיסידיה",
      challenge: "לכם תחילה היה צריך להישמע דבר האלוהים...",
      easy: {
        question: "היכן פאולוס הטיף כשהגיע לעיר?",
        options: [
          "בכיכר הציבורית",
          "קודם כל בבית הכנסת",
          "בבתי העשירים",
          "במקדשים פגאניים"
        ],
        hint: "הוא תמיד התחיל עם עמו",
        funFact: "🕍 אסטרטגיה מיסיונרית: תחילה ליהודים, אחר כך לגויים!"
      },
      medium: {
        question: "כיצד היהודים הגיבו למסר של פאולוס?",
        options: [
          "כולם קיבלו אותו",
          "התפצלו: חלקם האמינו, אחרים התנגדו",
          "נשארו אדישים",
          "גירשו אותו מיד"
        ],
        hint: "פילוג קלאסי מול הבשורה",
        funFact: "⚖️ הבשורה תמיד מחלקת: קבלה או דחייה, לא אדישות!"
      },
      hard: {
        question: "מדוע פאולוס פונה לגויים?",
        options: [
          "הוא העדיף את הגויים",
          "הדחייה של היהודים פותחת את הדלת לאומות",
          "זה היה יותר קל",
          "הוא נטש את משימתו"
        ],
        hint: "מדובר בהתגשמות נבואית",
        funFact: "🚪 'אור לגויים' - נבואת ישעיהו התגשמה על ידי פאולוס!"
      }
    },

    69: {
      name: "ריפוי בליסטרה",
      challenge: "האלים בדמות בני אדם ירדו אלינו!",
      easy: {
        question: "את מי ריפא פאולוס בליסטרה?",
        options: [
          "עיוור",
          "פיסח מלידה",
          "חירש-אילם",
          "מצורע"
        ],
        hint: "מישהו שמעולם לא הלך",
        funFact: "🦵 נס מרהיב: 'קום זקוף על רגליך!' - אמונה מרפאת!"
      },
      medium: {
        question: "למי ההמון חשב את פאולוס ובר-נבא?",
        options: [
          "מלכים",
          "אלים (זאוס והרמס)",
          "קוסמים",
          "נביאים"
        ],
        hint: "אלוהויות הפנתיאון היווני",
        funFact: "⚡ בר-נבא = זאוס (מרשים), פאולוס = הרמס (נואם) - אי הבנה תרבותית!"
      },
      hard: {
        question: "כיצד פאולוס הגיב לפולחן עבודה זרה זה?",
        options: [
          "מקבל את הכבוד",
          "קורע את בגדיו ומטיף על האלוהים האמיתי",
          "שותק מנימוס",
          "מנצל את המצב"
        ],
        hint: "דחייה מוחלטת של עבודה זרה",
        funFact: "👔 קריעת בגדים = אימה יהודית מפני עבודה זרה - יושרה מוחלטת!"
      }
    },

    70: {
      name: "סקילה ותחייה",
      challenge: "כאשר התלמידים הקיפו אותו, הוא קם ונכנס לעיר...",
      easy: {
        question: "מה עשו תושבי ליסטרה לפאולוס?",
        options: [
          "כלאו אותו",
          "סקלו אותו",
          "הגלו אותו",
          "צלבו אותו"
        ],
        hint: "העונש המסורתי היהודי",
        funFact: "🪨 מ'אלוהים' ל'מת' ביום אחד - חוסר עקביות של ההמון האנושי!"
      },
      medium: {
        question: "מה עשה פאולוס לאחר שנסקל?",
        options: [
          "ברח מהעיר",
          "התחבא",
          "קם וחזר לעיר",
          "הלך לבית חולים"
        ],
        hint: "אומץ על-טבעי לאחר מוות משוער",
        funFact: "💪 תחייה נסית או ריפוי אלוהי - אומץ מדהים!"
      },
      hard: {
        question: "מה חושף רדיפה זו על מחיר העדות?",
        options: [
          "צריך להימנע מקונפליקטים",
          "להעיד עבור המשיח עלול לעלות בחיים",
          "פאולוס היה לא זהיר",
          "הרדיפה היא חסרת תועלת"
        ],
        hint: "מדובר במחיר של עדות אותנטית",
        funFact: "✝️ 'בצרות רבות עלינו להיכנס' - ריאליזם של פאולוס!"
      }
    },

    71: {
      name: "מועצת ירושלים",
      challenge: "אם לא תימולו, לא תוכלו להיוושע...",
      easy: {
        question: "איזה ויכוח חשוב התקיים במועצת ירושלים?",
        options: [
          "הטבילה",
          "ברית המילה של הגויים שהתגיירו",
          "יום השבת",
          "התרומות"
        ],
        hint: "האם היה צורך להפוך ליהודי כדי להיות נוצרי?",
        funFact: "✂️ המשבר הגדול הראשון: נצרות או יהדות-נצרות?"
      },
      medium: {
        question: "מהי החלטת המועצה הסופית?",
        options: [
          "ברית מילה חובה",
          "חופש לגויים עם כמה המלצות",
          "הפרדה מוחלטת מהיהודים",
          "דחיית ההחלטה"
        ],
        hint: "פתיחות לגויים ללא מגבלה משמעותית",
        funFact: "🆓 מהפכה היסטורית: הבשורה משוחררת מחוק משה!"
      },
      hard: {
        question: "מה החשיבות של מועצה זו לכנסייה האוניברסלית?",
        options: [
          "אירוע משני",
          "היא מבססת את האוניברסליות של הישועה באמונה בלבד",
          "היא מפצלת את הכנסייה",
          "היא מחזקת את החוקיות"
        ],
        hint: "מדובר ביסוד הכנסייה האוניברסלית",
        funFact: "🌍 ללא החלטה זו, הנצרות הייתה נשארת כת יהודית!"
      }
    },

    72: {
      name: "המסע השני: טימותאוס",
      challenge: "פאולוס רצה לקחת אותו איתו ומל אותו בגלל היהודים...",
      easy: {
        question: "מי הצטרף לפאולוס כעוזר צעיר?",
        options: ["מרקוס", "לוקס", "טימותאוס", "טיטוס"],
        hint: "'הבן האהוב' של פאולוס",
        funFact: "👦 טימותאוס: ילד פלא צעיר שהפך לזרועו הימנית של פאולוס - חניכה מוצלחת!"
      },
      medium: {
        question: "מדוע פאולוס מל את טימותאוס למרות החופש שהושג?",
        options: [
          "מחובה משפטית",
          "מאסטרטגיה מיסיונרית בקרב היהודים",
          "ממסורת",
          "מטעות"
        ],
        hint: "חוכמה מעשית להימנע ממכשולים",
        funFact: "🎯 חופש עם חוכמה: 'להיות הכל לכולם כדי להציל חלקם'!"
      },
      hard: {
        question: "כיצד עמדה זו ממחישה גמישות מיסיונרית?",
        options: [
          "פאולוס היה לא עקבי",
          "הוא התאים את השיטה שלו מבלי להתפשר על הבשורה",
          "הוא נכנע ללחץ",
          "הוא היה צבוע"
        ],
        hint: "מדובר בחוכמה הקשרית",
        funFact: "⚖️ עקרונות מוצקים, שיטות גמישות - אמנות העדות היעילה!"
      }
    },

    73: {
      name: "חזון האיש המקדוני",
      challenge: "עבור למקדוניה ועזור לנו!",
      easy: {
        question: "מה ראה פאולוס בחזון הלילי שלו?",
        options: [
          "מלאך",
          "איש מקדוני שקורא לו",
          "ישו מדבר איתו",
          "אור גדול"
        ],
        hint: "קריאת עזרה מאירופה",
        funFact: "🌉 חזון מכריע: הבשורה חוצה לאירופה - נקודת מפנה היסטורית!"
      },
      medium: {
        question: "מהי העיר האירופית הראשונה שבושרה?",
        options: [
          "אתונה",
          "קורינתוס",
          "פיליפי",
          "תסלוניקי"
        ],
        hint: "מושבה רומית במקדוניה",
        funFact: "🏛️ פיליפי: הקהילה האירופית הראשונה - היבשת השתנתה לנצח!"
      },
      hard: {
        question: "מה מסמל חזון זה עבור ההיסטוריה של הנצרות?",
        options: [
          "חלום רגיל",
          "ההתרחבות ההשגחתית מערבה",
          "הזיה",
          "שינוי תוכנית"
        ],
        hint: "מדובר בהשגחה המכוונת את ההיסטוריה",
        funFact: "🗺️ בלי החזון הזה, אירופה הייתה יכולה להישאר פגאנית - תוכנית אלוהית!"
      }
    },

    74: {
      name: "לידיה, הגיירת האירופית הראשונה",
      challenge: "ה' פתח את לבה של לידיה כדי להקשיב...",
      easy: {
        question: "מה הייתה המקצוע של לידיה?",
        options: [
          "אופה",
          "סוחרת ארגמן",
          "אורגת",
          "קדרנית"
        ],
        hint: "מסחר יוקרה של התקופה",
        funFact: "🟣 ארגמן = צבע מלכותי יקר מאוד - לידיה הייתה משגשגת!"
      },
      medium: {
        question: "היכן פאולוס פגש את לידיה?",
        options: [
          "בשוק",
          "על שפת הנהר במהלך תפילה",
          "בביתה",
          "בבית הכנסת"
        ],
        hint: "מקום תפילה בשטח פתוח",
        funFact: "🏞️ לא היה בית כנסת בפיליפי - תפילה ליד המים לפי המסורת!"
      },
      hard: {
        question: "מה חושף הגיור של לידיה על העבודה האלוהית?",
        options: [
          "היא הייתה נוטה",
          "אלוהים פותח לבבות מוכנים לקבל את דברו",
          "זה היה צירוף מקרים",
          "פאולוס היה משכנע"
        ],
        hint: "מדובר בפעולה אלוהית בגיור",
        funFact: "💝 'ה' פתח את לבה' - אלוהים מכין ופותח נשמות!"
      }
    },

    75: {
      name: "כלא בפיליפי",
      challenge: "בחצות הלילה פאולוס וסילס התפללו ושרו הלל לאלוהים...",
      easy: {
        question: "מדוע פאולוס וסילס נכלאו?",
        options: [
          "גניבה",
          "הפרעה לסדר הציבורי בגירוש שד",
          "חילול השם",
          "מרד"
        ],
        hint: "ריפוי של שפחה מגדת עתידות",
        funFact: "💸 לשחרר נשמה עולה ביוקר למנצלים שלה - רדיפה כלכלית!"
      },
      medium: {
        question: "מה עשו פאולוס וסילס בכלא?",
        options: [
          "התלוננו",
          "התפללו ושרו",
          "הכינו את ההגנה שלהם",
          "ישנו"
        ],
        hint: "שבח למרות האזיקים",
        funFact: "🎵 שירי הלל בחצות בכלא - אמונה בלתי מעורערת שמרשימה!"
      },
      hard: {
        question: "כיצד יחסם שינה את המצב?",
        options: [
          "לא הייתה לו השפעה",
          "הוא המיר את הסוהר לאחר רעידת האדמה",
          "הוא הרגיז את השומרים",
          "הוא הוציא אותם מדעתם"
        ],
        hint: "עדות חזקה בדוגמה",
        funFact: "🌍 רעידת אדמה + עדות = גיור של הסוהר ומשפחתו!"
      }
    },

    76: {
      name: "באתונה: האריאופגוס",
      challenge: "את אשר אתם עובדים בלי לדעת, זאת אני מבשר לכם...",
      easy: {
        question: "לאיזה מזבח פאולוס התייחס באתונה?",
        options: [
          "לאל זאוס",
          "לאל הלא נודע",
          "לאפולו",
          "לאתנה"
        ],
        hint: "כתובת מסתורית ששימשה כנקודת התחלה",
        funFact: "🏛️ 'לאל הלא נודע' - נקודת מגע גאונית עם הפילוסופיה היוונית!"
      },
      medium: {
        question: "לפני מי פאולוס הטיף באתונה?",
        options: [
          "ההמון הרגיל",
          "הפילוסופים האפיקוריים והסטואיים באריאופגוס",
          "כוהני המקדשים",
          "הקיסר הרומי"
        ],
        hint: "האליטה האינטלקטואלית היוונית",
        funFact: "🧠 אריאופגוס = הרווארד העתיק - פאולוס מול החושבים הגדולים ביותר!"
      },
      hard: {
        question: "מה הייתה תגובת האתונאים לתחייה?",
        options: [
          "קבלה פה אחד",
          "פילוג: לעג של חלקם, עניין של אחרים",
          "זעם כללי",
          "אדישות מוחלטת"
        ],
        hint: "תגובה טיפוסית של אינטלקטואלים לתעלומה זו",
        funFact: "🤔 תחייה = אבן נגף לאינטליגנציה האנושית הגאה!"
      }
    },

    77: {
      name: "קורינתוס: פאולוס אורג האוהלים",
      challenge: "נשאר עמהם ועבד, כי באומנותם היו אורגי אוהלים...",
      easy: {
        question: "באיזו מקצוע פאולוס עסק כדי להתפרנס?",
        options: [
          "דייג",
          "אורג אוהלים",
          "סופר",
          "סוחר"
        ],
        hint: "מלאכת יד שלמד",
        funFact: "⛺ פאולוס: שליח-בעל מלאכה - כבוד העבודה הידנית בקרב הנוצרים!"
      },
      medium: {
        question: "אצל מי פאולוס התארח בקורינתוס?",
        options: [
          "באכסניה",
          "אצל עקילס ופריסקילה",
          "אצל המושל",
          "בבית הכנסת"
        ],
        hint: "זוג אורגי אוהלים כמוהו",
        funFact: "👫 עקילס ופריסקילה: זוג מיסיונרי מופת - אירוח נוצרי!"
      },
      hard: {
        question: "מדוע פאולוס עבד בידיו?",
        options: [
          "רק מצורך כלכלי",
          "כדי לא להיות נטל ולאמת את עדותו",
          "ממסורת משפחתית",
          "כי הוא אהב את המקצוע הזה"
        ],
        hint: "מדובר באי תלות ואמינות",
        funFact: "💼 עצמאות כלכלית = חופש דיבור - פאולוס לא היה תלוי באף אחד!"
      }
    },

    78: {
      name: "מהומה באפסוס",
      challenge: "גדולה ארטמיס האפסים!",
      easy: {
        question: "מי עורר את המהומה נגד פאולוס באפסוס?",
        options: [
          "הרשויות הרומיות",
          "דימיטריוס הצורף והבעלי מלאכה",
          "הפילוסופים",
          "הכוהנים היהודיים"
        ],
        hint: "אלה שייצרו מקדשי ארטמיס",
        funFact: "🏛️ השביתה הראשונה בהיסטוריה: הבשורה מאיימת על הכלכלה האלילית!"
      },
      medium: {
        question: "כמה זמן פאולוס לימד באפסוס?",
        options: [
          "6 חודשים",
          "שנה",
          "שנתיים",
          "3 שנים"
        ],
        hint: "השהות המיסיונרית הארוכה ביותר שלו",
        funFact: "📅 3 שנים של הוראה אינטנסיבית - אפסוס הפך למרכז מיסיונרי חשוב!"
      },
      hard: {
        question: "מה חושפת מהומה זו על ההשפעה החברתית של הבשורה?",
        options: [
          "הבשורה לא משנה דבר",
          "היא משנה מבנים כלכליים וחברתיים",
          "היא נוגעת רק לדת",
          "היא נמנעת מקונפליקטים"
        ],
        hint: "מדובר בשינוי חברתי עמוק",
        funFact: "💰 כשהבשורה מתקדמת, האלילים מאבדים את השוק שלהם - השפעה כלכלית!"
      }
    }
  }
};

export default chapter6Translations;
